import React from 'react';
import PropTypes from 'prop-types';
import { parse, format } from 'libphonenumber-js';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import * as GA from 'ga';

const formatPhone = number => format(parse(number), 'International');

class PhonesList extends React.Component {
  static propTypes = {
    phones: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    offerId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  showPhones = () => {
    this.setState({ visible: !this.state.visible });
  };

  render() {
    if (!this.state.visible) {
      return (
        <Button color="link" size="sm" onClick={this.showPhones}>
          <FormattedMessage
            id="phoneslist.btn.title"
            defaultMessage="показати телефони"
            description=""
          />
        </Button>
      );
    }

    GA.offerPhonesShown(this.props.offerId);
    const phones = this.props.phones.map(item => (
      <li key={item.id}>
        <a href={`tel:${item.number}`}>{formatPhone(item.number)}</a>
        {item.description && <small className="ml-3">{item.description}</small>}
      </li>
    ));
    return <ul className="list-unstyled">{phones}</ul>;
  }
}

export default PhonesList;
